import {
  PolicyCreateRequest,
  PolicyDeleteResponse,
  PolicyDocxConversionResponse,
  PolicyListResponse,
  PolicyResponse,
  PolicyUpdateRequest,
} from '@/types/service/policy';

import { baseProtectedApi } from '@/store/baseApi';

export const policyApi = baseProtectedApi.injectEndpoints({
  endpoints: (builder) => ({
    createPolicy: builder.mutation<PolicyResponse, PolicyCreateRequest>({
      query: (data) => ({
        url: '/v1/protected/policies',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Policy', 'PolicyList'],
    }),
    getPolicies: builder.query<PolicyListResponse, void>({
      query: () => ({
        url: '/v1/protected/policies',
        method: 'GET',
      }),
      providesTags: ['PolicyList'],
    }),
    getPolicy: builder.query<PolicyResponse, number>({
      query: (policyId) => ({
        url: `/v1/protected/policies/${policyId}`,
        method: 'GET',
      }),
      providesTags: ['Policy'],
    }),
    updatePolicy: builder.mutation<PolicyResponse, { policyId: number; data: PolicyUpdateRequest }>(
      {
        query: ({ policyId, data }) => ({
          url: `/v1/protected/policies/${policyId}`,
          method: 'PATCH',
          data,
        }),
        invalidatesTags: ['Policy', 'PolicyList'],
      },
    ),
    deletePolicy: builder.mutation<PolicyDeleteResponse, number>({
      query: (policyId) => ({
        url: `/v1/protected/policies/${policyId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Policy', 'PolicyList'],
    }),
    convertPolicyDocx: builder.mutation<PolicyDocxConversionResponse, File>({
      query: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return {
          url: '/v1/protected/policies/convert-docx',
          method: 'POST',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        };
      },
    }),
  }),
});

export const {
  useCreatePolicyMutation,
  useGetPoliciesQuery,
  useGetPolicyQuery,
  useUpdatePolicyMutation,
  useDeletePolicyMutation,
  useConvertPolicyDocxMutation,
} = policyApi;
